
<script setup>

  import { ref, watch, onMounted } from 'vue';

  import { ArrowRightCircleIcon } from '@heroicons/vue/24/outline';

  import { seenPlayerDialog } from '../stores/activity-3.js';

  import backgroundPath from '../images/paper-background.jpg';

  const ready = ref( false );

  onMounted( () => {

    watch( seenPlayerDialog, () => {

      if ( seenPlayerDialog.value ) setTimeout( () => ready.value = true, 100 );

    }, { immediate: true } );

  } );

</script>

<template>

  <article>

    <div class="grid items-center justify-center min-h-view bg-fixed bg-cover bg-center"
    
      :style="{ backgroundImage: `url( ${ backgroundPath } )` }">

      <div class="p-6 md:p-12 lg:p-24">

        <div class="max-w-xl">

          <h2 class="pb-6 border-b-[3px] border-black">

            <div class="text-xl tracking-narrow font-semibold uppercase">Activity 3</div>

            <div class="text-4xl md:text-5xl font-heading uppercase">The Essence of Life at Lewis</div>

          </h2>

          <p class="mt-8 leading-7 text-neutral-700">

            Lewis was a place for African Americans at a time when there

            weren't many places away from home where they could feel safe

            and accepted. They made long-lasting memories at Lewis.

          </p>

          <h3 class="mt-8 text-2xl md:text-3xl font-medium font-serif italic">About This Activity</h3>

          <p class="mt-4 leading-7 text-neutral-700">

            Meet the real-life staff and visitors of Lewis Mountain and listen
            
            to their personal experiences. Then, pick one of three

            creative writing scenarios and write your own letter home

            describing your "Life at Lewis."

          </p>

          <RouterLink
          
            class="inline-flex items-center gap-4 px-6 py-4 mt-12 text-white font-bold text-white bg-green-700 transition-colors
            
              hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
          
            to="/activity/3/part/1">

            <span>Continue</span>

            <ArrowRightCircleIcon class="w-8" />

          </RouterLink>

        </div>

      </div>

    </div>

  </article>

</template>
